module.exports = __webpack_public_path__ + "img/lg_ring_r_c_null_1@3x.bc31e9c6.png";